<template>
    <v-container fluid>
        <v-row>
            <ImageViewer
                :images="imageList"
                :toggler="lightboxShow"
                :index="lighboxIndex"
                @closeViewer="lightboxShow = false"
            >
            </ImageViewer>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ category.label }}
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <v-btn icon v-bind="attrs" @click="seeMore = !seeMore" v-on="on">
                                    <v-icon small>fas fa-caret-down</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('tooltips.seeMore') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="seeMore == true">
                            <v-col>
                                <v-data-table
                                    :headers="objectHeaders"
                                    :items="objectList"
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr :class="{'cursor-pointer': true}">
                                            <td @click="$emit('restore', row.item.id)" class="font-weight-bold">
                                                {{ row.item.document_type_display }} &nbsp;
                                                <v-btn
                                                    depressed
                                                    @click="fileClicked(row.item)"
                                                    icon
                                                    v-if="row.item.uploaded_file.link != ''"
                                                >
                                                    <v-icon small>fas fa-eye</v-icon>
                                                </v-btn>
                                            </td>
                                            <td @click="$emit('restore', row.item.id)">
                                                {{ row.item.issuing_country_display }}
                                            </td>
                                            <td @click="$emit('restore', row.item.id)">
                                                {{ row.item.issued_by }}
                                            </td>
                                            <td @click="$emit('restore', row.item.id)">
                                                {{ row.item.document_number }}
                                            </td>
                                            <td @click="$emit('restore', row.item.id)">
                                                {{ row.item.date_issued_display }}
                                            </td>
                                            <td @click="$emit('restore', row.item.id)" class="font-weight-bold">
                                                {{ row.item.date_of_expiry_display }}
                                            </td>
                                            <td v-if="inEditMode">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{on, attrs}">
                                                        <v-btn icon v-bind="attrs" @click="restore(row.item)" v-on="on">
                                                            <v-icon small>fas fa-undo</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ $t('tooltips.restore') }}</span>
                                                </v-tooltip>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ImageViewer from './trinkets/ImageViewer';
export default {
    name: 'SeafarerDocumentsTable',
    components: {ImageViewer},
    props: ['seafarer', 'category', 'reload', 'inEditMode'],
    data: function () {
        return {
            imageList: [],
            imageFormats: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            lightboxShow: false,
            lighboxIndex: 0,
            objectList: [],
            objectHeaders: [
                {text: this.$t('fields.documentType'), sortable: false},
                {text: this.$t('fields.issuingCountry'), sortable: false},
                {text: this.$t('fields.issuedBy'), sortable: false},
                {text: this.$t('fields.documentNumber'), sortable: false},
                {text: this.$t('fields.dateIssued'), sortable: false},
                {text: this.$t('fields.dateOfExpiry'), sortable: false},
                {text: '', value: 'actions', type: '', sortable: false, allowFilter: false},
            ],
            seeMore: true,
        };
    },

    watch: {
        reload: {
            handler: function () {
                if (this.reload == 'archive') {
                    this.reloadData();
                }
            },
            deep: true,
        },
    },

    methods: {
        fileClicked(item) {
            let link = item.uploaded_file.link;
            if (
                this.imageFormats.includes(
                    item.uploaded_file.original_name.slice(
                        ((item.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                    ),
                )
            ) {
                const index = this.imageList.indexOf(link);
                if (index !== null && index != -1) {
                    this.lighboxIndex = index;
                }
                this.lightboxShow = true;
            } else {
                window.open(link);
            }
        },
        restore(item) {
            let vm = this;
            let objectId = item.id;
            this.$verify(this.$t('alerts.restoreQuestion'), (result) => {
                if (result) {
                    vm.$APICall('put', 'restore-seafarer-documents/' + objectId, {}, (data, succes) => {
                        if (succes) {
                            this.reloadData();
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },

        reloadData() {
            let vm = this;
            let category = this.category.value;
            this.$APICall(
                'get',
                'seafarer-archive-documents/' + this.seafarer.id,
                {category},
                (data, success) => {
                    if (success) {
                        vm.objectList = data.items;
                        vm.objectList.forEach((element) => {
                            if (element != null) {
                                if (
                                    vm.imageFormats.includes(
                                        element.uploaded_file.original_name.slice(
                                            ((element.uploaded_file.original_name.lastIndexOf('.') - 1) >>> 0) + 2,
                                        ),
                                    )
                                ) {
                                    vm.imageList.push(element.uploaded_file.link);
                                }
                            }
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        this.reloadData();
    },
};
</script>
<style scoped>
.v-data-table::v-deep th {
    font-size: 14px !important;
    font-weight: 800;
}
.v-data-table::v-deep .v-data-table__wrapper {
    min-height: 96px; /* dense zaglavlje 32px + 2 dense retka po 32px */
}
</style>
